import { IFeatures } from '@bciti/types';
import { createAction, props } from '@ngrx/store';
import { IFECategory } from '../components/forms/category/bciti-category-input.component';
import { Colour, GetAdminOrganisationAreas, Navigation, NavigationItem, OrganisationPayload } from '../global.model';
import {
    CreateServiceCategoryPayload,
    CreateServiceStatusPayload,
    ServiceCategoryAdminResponse,
    Service,
    ServiceStatusAdminResponse,
    UpdateServiceCategoryPayload,
    UpdateServiceStatusPayload,
    UpdateServicePayload,
} from '../services/service-state/service-state.model';
import { Collection } from '../services/collections/collections.model';
import { AccessControl, AssignPayload, CreateRoleDto, UpdateRoleDto } from '../services/access-control/access-control.model';

export const ClearGlobalStateAction = createAction('[Global] - Clear Global State');

export const GetOrganisationsAction = createAction('[Global] - Get Organisations');
export const GetOrganisationsSuccessAction = createAction('[Global] - Get Organisations Success', props<{ organisations: OrganisationPayload[] }>());
export const GetOrganisationsErrorAction = createAction('[Global] - Get Organisations Error', props<{ error?: any }>());
export const SetOrganisationsAction = createAction('[Global] - Set Organisations', props<{ organisations: OrganisationPayload[] }>());

export const SetOrganisationAction = createAction('[Global] - Set Organisation', props<{ organisation: OrganisationPayload }>());

export const SetIsGenericUrlAction = createAction('[Global] - Set Is Generic Url', props<{ isGenericUrl: boolean }>());

export const RefreshOrganisationAction = createAction('[Global - Refresh Organisation');

export const GetOrganisationErrorAction = createAction('[Global] - Get Organisation Error', props<{ error?: any }>());

export const GetOrganisationConfigurationAction = createAction('[Global] - Get Organisation Configuration');

export const SetOrganisationConfigurationAction = createAction('[Global] - Set Organisation Configuration', props<{ configuration }>());

export const GetOrganisationFeaturesConfigurationAction = createAction('[Global] - Get Organisation Features Configuration');
export const GetOrganisationFeaturesConfigurationSuccessAction = createAction('[Global] - Get Organisation Features Configuration Success');
export const GetOrganisationFeaturesConfigurationErrorAction = createAction('[Global] - Get Organisation Features Configuration Error', props<{ error?: any }>());
export const SetOrganisationFeaturesConfigurationAction = createAction('[Global] - Set Organisation Features Configuration', props<{ features: IFeatures }>());

export const GetNavigationAction = createAction('[Global] - Get Navigation');

export const SetNavigationAction = createAction('[Global] - Set navigation', props<{ navigation: Navigation }>());

export const SetNavigationMainItemsAction = createAction('[Global] - Set navigation main items', props<{ items: NavigationItem[] }>());

export const SetNavigationSecItemsAction = createAction('[Global] - Set navigation secondary items', props<{ items: NavigationItem[] }>());

export const SetLanguageAction = createAction('[Global] - Set language', props<{ language: string }>());

export const SaveLanguageAction = createAction('[Global] - Save language', props<{ language: string }>());

export const ResetLanguageAction = createAction('[Global] - Reset language');

export const InitLanguageAction = createAction('[Global] - Init language');

export const InitLanguageFromMobileAction = createAction('[Global] - Init language from mobile');

// Services Categories

export const GetServiceCategoriesAction = createAction('[Global] - Get Service Categories');

export const GetServiceCategoriesSuccessAction = createAction('[Global] - Get Service Categories Success');

export const GetServiceCategoriesErrorAction = createAction('[Global] - Get Service Categories Error', props<{ error: any }>());

export const SetServiceCategoriesAction = createAction('[Global] - Set Service Categories', props<{ categories: ServiceCategoryAdminResponse[] }>());

export const UpdateServiceCategoryAction = createAction('[Global] - Update Service Category', props<{ category: UpdateServiceCategoryPayload }>());

export const UpdateServiceCategorySuccessAction = createAction('[Global] - Update Service Category Success', props<{ category: ServiceCategoryAdminResponse }>());

export const UpdateServiceCategoryErrorAction = createAction('[Global] - Update Service Category Error', props<{ error: any }>());

export const CreateServiceCategoryAction = createAction('[Global] - Create Service Category', props<{ category: CreateServiceCategoryPayload }>());

export const CreateServiceCategorySuccessAction = createAction('[Global] - Create Service Category Success', props<{ category: ServiceCategoryAdminResponse }>());

export const CreateServiceCategoryErrorAction = createAction('[Global] - Create Service Category Error', props<{ error: any }>());

export const DeleteServiceCategoryAction = createAction('[Global] - Delete Service Category', props<{ category: IFECategory }>());

export const DeleteServiceCategorySuccessAction = createAction('[Global] - Delete Service Category Success', props<{ category?: IFECategory }>());

export const DeleteServiceCategoryErrorAction = createAction('[Global] - Delete Service Category Error', props<{ error: any }>());

// Service statuses

export const GetServiceStatusesAction = createAction('[Global] - Get Service Statuses');

export const GetServiceStatusesSuccessAction = createAction('[Global] - Get Service Statuses Success');

export const GetServiceStatusesErrorAction = createAction('[Global] - Get Service Statuses Error', props<{ error: any }>());

export const SetServiceStatusesAction = createAction('[Global] - Set Service Statuses', props<{ statuses: ServiceStatusAdminResponse[] }>());

export const UpdateServiceStatusAction = createAction('[Global] - Update Service Status', props<{ status: UpdateServiceStatusPayload }>());

export const UpdateServiceStatusSuccessAction = createAction('[Global] - Update Service Status Success', props<{ status: ServiceStatusAdminResponse }>());

export const UpdateServiceStatusErrorAction = createAction('[Global] - Update Service Status Error', props<{ error: any }>());

export const CreateServiceStatusAction = createAction('[Global] - Create Service Status', props<{ status: CreateServiceStatusPayload }>());

export const CreateServiceStatusSuccessAction = createAction('[Global] - Create Service Status Success', props<{ status: ServiceStatusAdminResponse }>());

export const CreateServiceStatusErrorAction = createAction('[Global] - Create Service Status Error', props<{ error: any }>());

export const DeleteServiceStatusAction = createAction('[Global] - Delete Service Status', props<{ status: ServiceStatusAdminResponse }>());

export const DeleteServiceStatusSuccessAction = createAction('[Global] - Delete Service Status Success', props<{ status?: ServiceStatusAdminResponse }>());

export const DeleteServiceStatusErrorAction = createAction('[Global] - Delete Service Status Error', props<{ error: any }>());

// Services

export const ClearServicesModuleAction = createAction('[Global] - Clear Services Module');

export const GetServicesAction = createAction('[Global] - Get Services');

export const GetServicesSuccessAction = createAction('[Global] - Get Services Success');

export const GetServicesErrorAction = createAction('[Global] - Get Services Error', props<{ error: any }>());

export const SetServicesAction = createAction('[Global] - Set Services', props<{ services: Service[] }>());

export const CreateServiceAction = createAction('[Global] - Create Service', props<{ service: Service }>());

export const CreateServiceSuccessAction = createAction('[Global] - Create Service Success', props<{ service: Service }>());

export const CreateServiceErrorAction = createAction('[Global] - Create Service Error', props<{ error: any }>());

export const UpdateServiceAction = createAction('[Global] - Update Service', props<{ service: UpdateServicePayload }>());

export const UpdateServiceSuccessAction = createAction('[Global] - Update Service Success', props<{ service: Service }>());

export const UpdateServiceErrorAction = createAction('[Global] - Update Service Error', props<{ error: any }>());

export const UpdateServiceOrderAction = createAction('[Global] - Update Service Order', props<{ service: Service }>());

export const UpdateServiceOrderSuccessAction = createAction('[Global] - Update Service Order Success', props<{ changedService: Service; services: Service[] }>());

export const UpdateServiceOrderErrorAction = createAction('[Global] - Update Service Order Error', props<{ error: any }>());

export const DeleteServiceAction = createAction('[Global] - Delete Service', props<{ service: Service }>());

export const DeleteServiceSuccessAction = createAction('[Global] - Delete Service Success', props<{ service: Service }>());

export const DeleteServiceErrorAction = createAction('[Global] - Delete Service Error', props<{ error: any }>());

export const DuplicateServiceAction = createAction('[Global] - Duplicate Service', props<{ service: Service }>());

export const DuplicateServiceSuccessAction = createAction('[Global] - Duplicate Service Success', props<{ service: Service }>());

export const DuplicateServiceErrorAction = createAction('[Global] - Duplicate Service Error', props<{ error: any }>());

// collections

export const ClearCollectionsModuleAction = createAction('[Global] - Clear Collections Module');

export const GetCollectionsAction = createAction('[Global] - Get Collections');

export const GetCollectionsSuccessAction = createAction('[Global] - Get Collections Success');

export const GetCollectionsErrorAction = createAction('[Global] - Get Collections Error', props<{ error: any }>());

export const SetCollectionsAction = createAction('[Global] - Set Collections', props<{ collections: Collection[] }>());

export const CreateCollectionAction = createAction('[Global] - Create Collection', props<{ collection: Collection }>());

export const CreateCollectionSuccessAction = createAction('[Global] - Create Collection Success', props<{ collection: Collection }>());

export const CreateCollectionErrorAction = createAction('[Global] - Create Collection Error', props<{ error: any }>());

export const UpdateCollectionAction = createAction('[Global] - Update Collection', props<{ collection: Collection }>());

export const UpdateCollectionSuccessAction = createAction('[Global] - Update Collection Success', props<{ collection: Collection }>());

export const UpdateCollectionErrorAction = createAction('[Global] - Update Collection Error', props<{ error: any }>());

export const DeleteCollectionAction = createAction('[Global] - Delete Collection', props<{ collection: Collection }>());

export const DeleteCollectionSuccessAction = createAction('[Global] - Delete Collection Success', props<{ collection: Collection }>());

export const DeleteCollectionErrorAction = createAction('[Global] - Delete Collection Error', props<{ error: any }>());

export const DuplicateCollectionAction = createAction('[Global] - Duplicate Collection', props<{ collection: Collection }>());

export const DuplicateCollectionSuccessAction = createAction('[Global] - Duplicate Collection Success', props<{ collection: Collection }>());

export const DuplicateCollectionErrorAction = createAction('[Global] - Duplicate Collection Error', props<{ error: any }>());

// Areas

export const ClearOrganisationAreasAction = createAction('[Global] - Clear Organisation Areas');

export const GetOrganisationAreasAction = createAction('[Global] - Get Organisation Areas');

export const GetOrganisationAreasSuccessAction = createAction('[Global] - Get Organisation Areas Success');

export const GetOrganisationAreasErrorAction = createAction('[Global] - Get Organisation Areas Error', props<{ error?: any }>());

export const SetOrganisationAreasAction = createAction('[Global] - Set Organisation Areas', props<{ areas: GetAdminOrganisationAreas[] }>());

export const CreateOrganisationAreaAction = createAction('[Global] - Create Organisation Area', props<{ area: GetAdminOrganisationAreas }>());

export const CreateOrganisationAreaSuccessAction = createAction('[Global] - Create Organisation Area Success', props<{ area: GetAdminOrganisationAreas }>());

export const CreateOrganisationAreaErrorAction = createAction('[Global] - Create Organisation Area Error', props<{ error?: any }>());

export const UpdateOrganisationAreaAction = createAction('[Global] - Update Organisation Area', props<{ area: GetAdminOrganisationAreas }>());

export const UpdateOrganisationAreaSuccessAction = createAction('[Global] - Update Organisation Area Success', props<{ area: GetAdminOrganisationAreas }>());

export const UpdateOrganisationAreaErrorAction = createAction('[Global] - Update Organisation Area Error', props<{ error?: any }>());

export const DeleteOrganisationAreaAction = createAction('[Global] - Delete Organisation Area', props<{ area: GetAdminOrganisationAreas }>());

export const DeleteOrganisationAreaSuccessAction = createAction('[Global] - Delete Organisation Area Success', props<{ area: GetAdminOrganisationAreas }>());

export const DeleteOrganisationAreaErrorAction = createAction('[Global] - Delete Organisation Area Error', props<{ error?: any }>());

export const GetOrganisationColourAction = createAction('[Global] - Get Organisation Colour');

export const GetOrganisationColourSuccessAction = createAction('[Global] - Get Organisation Colour Success', props<{ colour: Colour }>());

export const GetOrganisationColourFailureAction = createAction('[Global] - Get Organisation Colour Failure', props<{ error: any }>());

export const SetOrganisationColourAction = createAction('[Global] - Set Organisation Color', props<{ orgTag: string; colour: Colour }>());

export const SetOrganisationColourSuccessAction = createAction('[Global] - Set Organisation Color Success', props<{ orgTag: string; colour: Colour }>());

export const SetOrganisationColourFailureAction = createAction('[Global] - Set Organisation Color Failure', props<{ error: any }>());

// Access

export const ClearAccessModuleAction = createAction('[Global] - Clear Access Module');

export const GetAccessAction = createAction('[Global] - Get Access');

export const GetAccessSuccessAction = createAction('[Global] - Get Access Success');

export const GetAccessErrorAction = createAction('[Global] - Get Access Error', props<{ error: any }>());

export const SetAccessAction = createAction('[Global] - Set Access', props<{ access: AccessControl[] }>());

export const CreateAccessAction = createAction('[Global] - Create Access', props<{ access: CreateRoleDto }>());

export const CreateAccessSuccessAction = createAction('[Global] - Create Access Success', props<{ access: AccessControl }>());

export const CreateAccessErrorAction = createAction('[Global] - Create Access Error', props<{ error: any }>());

export const UpdateAccessAction = createAction('[Global] - Update Access', props<{ access: UpdateRoleDto; roleId: string }>());

export const UpdateAccessSuccessAction = createAction('[Global] - Update Access Success', props<{ access: AccessControl }>());

export const UpdateAccessErrorAction = createAction('[Global] - Update Access Error', props<{ error: any }>());

export const DeleteAccessAction = createAction('[Global] - Delete Access', props<{ access: AccessControl }>());

export const DeleteAccessSuccessAction = createAction('[Global] - Delete Access Success', props<{ access: AccessControl }>());

export const DeleteAccessErrorAction = createAction('[Global] - Delete Access Error', props<{ error: any }>());

export const BatchAssignRoleAction = createAction('[Global] - Batch Assign Role', props<{ assignments: AssignPayload[] }>());

export const BatchAssignRoleSuccessAction = createAction('[Global] - Batch Assign Role Success', props<{ assignments: AssignPayload[] }>());

export const BatchAssignRoleErrorAction = createAction('[Global] - Batch Assign Role Error', props<{ error: any }>());

export const AssignRoleAction = createAction('[Global] - Assign Access', props<{ roleId: string; userid: string }>());

export const AssignRoleSuccessAction = createAction('[Global] - Assign Access Success');

export const AssignRoleErrorAction = createAction('[Global] - Assign Access Error', props<{ error: any }>());
